// auth.selectors.ts
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AuthState } from './auth.state';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectToken = createSelector(selectAuthState, (state: AuthState) => state.token);

export const selectUser = createSelector(selectAuthState, (state: AuthState) => state.user);

export const selectAuthErrors = createSelector(selectAuthState, (state: AuthState) => state.errorLogs);

export const selectIsAuthenticated = createSelector(
  selectToken,
  (token) => !!token // Determine authentication status based on token
);

export const selectRoles = createSelector(selectAuthState, (state: AuthState) => state.roles);
